import { render, staticRenderFns } from "./FormColorPicker.vue?vue&type=template&id=7bf0f9aa&scoped=true&"
import script from "./FormColorPicker.vue?vue&type=script&lang=ts&"
export * from "./FormColorPicker.vue?vue&type=script&lang=ts&"
import style0 from "./FormColorPicker.vue?vue&type=style&index=0&id=7bf0f9aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf0f9aa",
  null
  
)

export default component.exports